import React from 'react';

const VideoSection = () => {
  return null;
};

export default VideoSection;
